import React from 'react';
import './Features.css';

import fans from '../../assets/fans.png';
import influencers from '../../assets/influencers.png';
import brands from '../../assets/brands.png';

const Features = () => {
  return (
    <section className="block">
      <article className="container grid grid--1X2 feature">
        <div className="feature__content">
          <p className="feature__topline">FOR FANS</p>
          <h3 className="feature__heading">
            Access the locked DM’s of your favorite influencers
          </h3>
          <p>
            Fans can be individuals, companies especially SMEs looking to
            contact influencers urgently or get them to work on a campaign with
            them. Fans can also set DM prices however they wish if they cannot
            pay for fixed prices set by influencers.
          </p>
        </div>
        <div className="feature__image">
          <img src={fans} alt="" />
        </div>
      </article>
      <article className="container grid grid--1X2 feature">
        <div className="feature__content">
          <p className="feature__topline">FOR INFLUENCERS</p>
          <h3 className="feature__heading">
            Connect with fans, brands while earning extra cash
          </h3>
          <p>
            Generally, anyone can get register as an influencer but only
            verified celebrities will get the verified tags. New “wanna-bee”
            celebrity can use the platform as a landing spot to manage their
            consultations by sending their Haelo links in other social media
            platform instead of “I can’t respond to DMs because they’re much”.{' '}
            <br />
            Influencers can set their DM prices; visitors can see it, pay for it
            and access the locked DMs of their favorite celebrities.
          </p>
        </div>
        <div className="feature__image">
          <img src={influencers} alt="" />
        </div>
      </article>
      <article className="container grid grid--1X2 feature">
        <div className="feature__content">
          <p className="feature__topline">FOR BRANDS</p>
          <h3 className="feature__heading">
            Get the brand ambassador of your choice
          </h3>
          <p>
            Brands can be individual brands, service brands or organization
            brands looking to contact influencers as brand ambassadors,
            marketing campaigns or business advice. <br />
            Brands can also set DM prices however they wish if they cannot pay
            for fixed prices set by influencers.
          </p>
        </div>
        <div className="feature__image">
          <img src={brands} alt="" />
        </div>
      </article>
    </section>
  );
};

export default Features;
